<template>
    <div class="dealpricebox">

        <!-- 遮罩 -->
        <div class="mask" @click="handlemask" v-show="faqshow"></div>

        <!-- faq预付款盒子 -->
        <div class="faq" v-show="faqshow">
            <div class="faq-title">参考预付款</div>
            <div class="faq-content">
                <p>挂单未成交时不占用预付款。<br>锁仓只占用单向（单边）预付款。<br>锁仓是指投资者做同品种数量相等但方向相反的开仓交易，以便不管价格向何方运动均不会使持仓盈亏再增减的一种操作方法。</p>
            </div>
            <div @click="removefaq" class="faq-bottom">我知道了</div>
        </div>

        <div class="dealpricebox-title">
            <p>可用预付款：<span>{{this.$store.state.payment?this.$store.state.payment:'--.--'}}</span> 美元</p>
            <p>参考预付款：<span>{{yfkflag?'$'+(parseFloat(yfk).toFixed(2)):'$'+(parseFloat(gdyfk).toFixed(2))}}</span><span><img @click="handlefaq()" style="width: 16px;height: 16px;display: block;margin-left: 4.33px;" src="@/assets/faq-icon.png" alt=""></span></p>
        </div>
        <ul>
            <li @click="select(index)" :class="[item.name == initlot?'active':'',item.name == gdinitlot?'actived':'']" v-for="(item,index) in lotsarr" :key="index">{{item.name}}手</li>
        </ul>
        <div class="setprice">
            <div class="left">止损止盈设置</div>
            <div class="right">
                <div class="box" v-show="!slideshow">
                    <div :class="jiage?'dsactive':'dsactived'" style="border-right-top-radius:0;border-right-bottom-radius:0;" @click="jg" class="right-price">价格</div>
                    <div :class="ds?'dsactive':'dsactived'" @click="handleds" class="right-amount">点数</div>
                </div>
                <img @click="changeicon" :style="{transform: !this.slideshow ? 'rotate(180deg)' : 'rotate(0deg)'}" src="@/assets/icon-down2.png" alt="">
            </div>
        </div>
        <div class="slide" v-show="!slideshow">

            <div class="slider-down" v-show="jiage">
                <!-- 市价交易里的价格 -->
                <div class="slide-item">
                    <div class="dealbox">
                        <div class="left">
                            <!-- 至少离市价$2.00 -->
                            <!-- !zhisunchang 监听黄金价格影响的止损，价格为空他就为false -->
                            <p>止损
                                <span v-show="!changgetext">{{this.$store.state.goldindex?'至少远离市价$2.00':'至少远离市价$0.20'}}</span>
                                <span v-show="changgetext && this.$store.state.goldindex">{{goldgdpricecg && !zhisunchang?gdzhisun:(goldgdpricecg && zhisunchang?comtotalzhisun:'至少远离市价$2.00')}}</span>
                                <span v-show="changgetext && !this.$store.state.goldindex">{{silvergdpricecg && !slzhisunchang?slgdzhisun:(silvergdpricecg && slzhisunchang?slcomtotalzhisun:'至少远离市价$0.20')}}</span>
                            </p>
                        </div>

                        <div class="ctrlbox">
                            <!-- 黄金减按钮 -->
                            <div class="main" v-show="this.$store.state.goldindex"><img @click="cut" src="@/assets/cut.png" alt=""></div>

                            <!-- 白银减按钮 -->
                            <div class="main" v-show="!this.$store.state.goldindex"><img @click="silvercut" src="@/assets/cut.png" alt=""></div>

                            <div class="right">

                                <!-- 黄金 -->
                                <!-- 止损 -->
                                <span v-show="this.$store.state.goldindex"><input type="num" placeholder="未设置" v-model.number="goldfirment"  @input="goldoninput"></span>

                                <!-- 白银 -->
                                <span style="width: 60px;" v-show="!this.$store.state.goldindex"><input type="num" placeholder="未设置" v-model.number="silverfirment"  @input="silveroninput"></span>
                                
                                <!-- 黄金加按钮 -->
                                <span v-show="this.$store.state.goldindex"><img @click="add" src="@/assets/add.png" alt=""></span>
                                
                                <!-- 白银加按钮 -->
                                <span v-show="!this.$store.state.goldindex"><img @click="silveradd" src="@/assets/add.png" alt=""></span>

                                <!-- 黄金清空 -->
                                <span style="font-size:14px;color:#999999;padding-left:5px" v-show="this.$store.state.goldindex" @click="reset">清空</span>

                                <!-- 白银清空 -->
                                <span style="font-size:14px;color:#999999;padding-left:5px" v-show="!this.$store.state.goldindex" @click="silverreset">清空</span>
                            </div>
                        </div>

                    </div>
                </div>

                <!-- 挂单交易里的价格 -->
                <div class="slide-item">
                    <div class="dealbox">
                        <div class="left">
                                                    <!-- !zhisunchang 监听黄金价格影响的止损，价格为空他就为false -->
                            <p>止盈
                                <span v-show="!changgetext">{{this.$store.state.goldindex?'至少远离市价$2.00':'至少远离市价$0.20'}}</span>
                                <span v-show="changgetext && this.$store.state.goldindex">{{goldgdpricecg && !zhiyingchang?gdzhiying:(goldgdpricecg && zhiyingchang?comtotalzhiying:'至少远离市价$2.00')}}</span>
                                <span v-show="changgetext && !this.$store.state.goldindex ">{{silvergdpricecg && !slzhiyingchang?slgdzhiying:(silvergdpricecg && slzhiyingchang?slcomtotalzhiying:'至少远离市价$0.20')}}</span>
                            </p>
                        </div>

                        <div class="ctrlbox">
                            <!-- 黄金减按钮 -->
                            <div class="main" v-show="this.$store.state.goldindex"><img @click="cuts" src="@/assets/cut.png" alt=""></div>

                            <!-- 白银减按钮 -->
                            <div class="main" v-show="!this.$store.state.goldindex"><img @click="silvercuts" src="@/assets/cut.png" alt=""></div>

                            <div class="right">

                                <!-- 黄金 --> 
                                <!-- 止盈 -->
                                <span v-show="this.$store.state.goldindex"><input type="num" placeholder="未设置" v-model.number="goldsecment"  @input="goldoninputs"></span>

                                <!-- 白银 -->
                                <span style="width: 60px;" v-show="!this.$store.state.goldindex"><input type="num" placeholder="未设置" v-model.number="silversecment"  @input="silveroninputs"></span>


                                <!-- 黄金加按钮 -->
                                <span v-show="this.$store.state.goldindex"><img @click="adds" src="@/assets/add.png" alt=""></span>

                                <!-- 白银加按钮 -->
                                <span v-show="!this.$store.state.goldindex"><img @click="silveradds" src="@/assets/add.png" alt=""></span>

                                <!-- 黄金清空 -->
                                <span style="font-size:14px;color:#999999;padding-left:5px" v-show="this.$store.state.goldindex" @click="resets">清空</span>

                                <!-- 白银清空 -->
                                <span style="font-size:14px;color:#999999;padding-left:5px" v-show="!this.$store.state.goldindex" @click="silverresets">清空</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div class="slider-down" v-show="ds">
                <div class="sliderdown-item">
                    <p>止损
                        <span v-show="!this.changgetext">{{zhisundianshu?getsjdszhisun:'>200'}}</span>
                        <span v-show="this.changgetext">{{gdzhisundianshu?getgddszhisun:'>200'}}</span>
                    </p>
                    <p>
                        <img @click="zhisundscut" src="@/assets/cut.png" alt="" class="cut">
                        <span>
                            <input v-show="!this.changgetext" type="number" placeholder="未设置" v-model="zhisundianshu" @input="onzhisunds">
                            <input v-show="this.changgetext" type="number" placeholder="未设置" v-model="gdzhisundianshu" @input="onzhisunds">
                        </span>
                        <img @click='zhisundsadd' src="@/assets/add.png" alt="" class="add">
                        <span @click="removedianshuzhisun">清空</span>
                    </p>
                </div>
                <div class="sliderdown-item">
                    <p>止盈
                        <span v-show="!this.changgetext">{{zhiyingdianshu?getsjdszhiying:'>200'}}</span>
                        <span v-show="this.changgetext">{{gdzhiyingdianshu?getgddszhiying:'>200'}}</span>
                    </p>
                    <p>
                        <img @click="zhiyingdscut" src="@/assets/cut.png" alt="" class="cut">
                        <span>
                            <input v-show="!this.changgetext" type="number" placeholder="未设置" v-model="zhiyingdianshu" @input="onzhiyingds">
                            <input v-show="this.changgetext" type="number" placeholder="未设置" v-model="gdzhiyingdianshu" @input="onzhiyingds">
                        </span>
                        <img @click="zhiyingdsadd" src="@/assets/add.png" alt="" class="add">
                        <span @click="removedianshuzhiying">清空</span>
                    </p>
                </div>
            </div>            

        </div>
    </div>
</template>

<script>
import { Message } from 'element-ui'
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
export default {
    props:{
        navtabcurrentindex:{
            type:Number
        },
        initlot:{
            type:Number,
        },
        gdinitlot:{
            type:Number
        },
        yfk:{
            type:Number
        },
        gdyfk:{
            type:Number
        },
        goldgdprice:{ //父组件传过来的黄金挂单价格
            type:null
        },
        silvergdprice:{//父组件传过来的白银挂单价格
            type:null
        },
        goldtsprice:{//父组件传过来的黄金停损限价
            type:null
        },
        silvertsprice:{//父组件传过来的白银停损限价
            type:null
        },
        goldDealTypePrice:{
            type:null //控制当黄金没有金额时第一次输入止盈止损
        },

        //清空黄金止盈止损价格 止盈止损点数
        gdzhisundss:{
            type:null
        },
        gdzhiyingdss:{
            type:null
        },
        gdgoldzhisun:{
            type:null
        },
        gdgoldzhiying:{
            type:null
        },

        //清空白银止盈止损价格 止盈止损点数
        gdsilverzyds:{
            type:null
        },
        gdsilverzsds:{
            type:null
        },
        gdsilverzs:{
            type:null
        },
        gdsilverzy:{
            type:null
        }
        
    },
    name:"dealprices",
    data(){
        return{
            dealyfk:null,
            dealgdyfk:null,
            flag:true,
            flags:true,
            goldfirment:null,//输入框设置数字初始值
            goldsecment:null,//输入框设置数字初始值
            clicktotal:0,
            clicktotals:0,

            faqshow:false,//faq预付款弹窗

            silverflag:true,
            silverflags:true,
            silverfirment:null,//白银第一框
            silversecment:null,//白银第二框
            silverclicktotal:0,//白银点击数
            silverclicktotals:0,//白银第二个框点击数
            
            goldflag:true,//判断黄金白银挂单页面
            gdzhisun:null,//黄金挂单止损
            gdzhiying:null,//黄金挂单止盈
            slgdzhisun:null,//白银挂单止损
            slgdzhiying:null,//白银挂单止盈

            jiage:true,//控制价格点数切换
            ds:false,//控制价格点数切换

            zhisundianshu:null,//止损点数
            zhiyingdianshu:null,//止盈点数

            gdzhisundianshu:null,//挂单止损点数
            gdzhiyingdianshu:null,//挂单止盈点数

            getsjdszhisun:null,//计算市价交易预计止损点数
            getsjdszhiying:null,//计算市价交易预计止盈点数

            getgddszhisun:null,//计算挂单交易预计止损点数
            getgddszhiying:null,//计算挂单交易预计止盈点数

            // comtotalzhisun:null,//计算止损盈亏
            // comtotalzhiying:null,//计算止盈盈亏

            dsclicktotal:0,//市价交易止损点数点击
            dsflag:true,//市价交易止损点数开关

            dsclicktotals:0,//市价交易止盈点数点击
            dsflags:true,//市价交易止盈点数开关

            gddsclicktotal:0,//挂单交易止损点数点击
            gddsflag:true,//挂单交易止损点数开关

            gddsclicktotals:0,//挂单交易止盈点数点击
            gddsflags:true,//挂单交易止盈点数开关

            yfkflag:true,//市价交易与挂单交易切换时预付款切换
            changgetext:false,//市价交易与挂单交易切换时止盈止损文本切换
            slchanggetext:false,

            zhisunchang:false,
            zhiyingchang:false,
            slzhisunchang:false,
            slzhiyingchang:false,

            goldgdpricecg:false,
            silvergdpricecg:false,

            slideshow:true,
            runTime:0,
            lotsarr:[
                {
                    name: '0.5',
                },
                {
                    name: '1',
                },
                {
                    name: '5',
                },
                {
                    name: '10',
                },
                {
                    name: '20',
                },
            ],
            active:""
        }
    },
    
    methods:{

        // 点击预付款faq图标
        handlefaq(){
            this.faqshow = true
        },

        // 点击取消faq弹窗
        removefaq(){
            this.faqshow = false
        },

        // 点击蒙层
        handlemask(){
            this.faqshow = false
        },

        // 控制价格点数切换
        jg(){

            this.ds = false
            this.jiage = true

            this.removedianshuzhisun() //清空止损点数
            this.removedianshuzhiying() //清空止盈点数
        
        },
        
        //控制价格点数切换
        handleds(){

            this.ds = true
            this.jiage = false

            this.reset() //清空黄金止损价格
            this.resets() //清空黄金止盈价格
            this.silverreset() //清空白银止损价格
            this.silverresets() //清空白银止盈价格

        },

        onzhisunds(e){
            if(!this.changgetext){
                this.zhisundianshu = e.target.value
            }else if(this.changgetext){
                this.gdzhisundianshu = e.target.value
            }
        },

        onzhiyingds(e){
            if(!this.changgetext){
                this.zhiyingdianshu = e.target.value
            }else if(this.changgetext){
                this.gdzhiyingdianshu = e.target.value
            }
        },

        // 市价交易点数止损减
        zhisundscut(){

            if(!this.changgetext){ //如果是市价交易页面

                var initnum = 1
                if(this.dsclicktotal == 0 && this.dsflag && !this.zhisundianshu){
                    this.zhisundianshu = 201
                }
                this.dsclicktotal++
                if(this.zhisundianshu <= 0) return false
                this.zhisundianshu = Number(this.Sub(this.zhisundianshu,initnum))

            }else if(this.changgetext){ //如果是挂单交易页面

                if(this.$store.state.goldindex && !this.goldgdprice){
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(!this.$store.state.goldindex && !this.silvergdprice){
                    this.$toast('请先输入挂单价格')
                    return false;
                }
                
                var initnum = 1
                if(this.gddsclicktotal == 0 && this.gddsflag && !this.gdzhisundianshu){
                    this.gdzhisundianshu = 201
                }
                this.gddsclicktotal++
                if(this.gdzhisundianshu <= 0) return false
                this.gdzhisundianshu = Number(this.Sub(this.gdzhisundianshu,initnum))

            }

        },

        // 市价交易点数止损加
        zhisundsadd(){
            
            if(!this.changgetext){ //如果是市价交易页面

                var initnum = 1
                if(this.dsclicktotal == 0 && this.dsflag && !this.zhisundianshu){
                    this.zhisundianshu = 199
                }
                this.dsclicktotal++
                this.zhisundianshu = this.NumberAdd(this.zhisundianshu,initnum)

            }else if(this.changgetext){ //如果是挂单交易页面

                if(this.$store.state.goldindex && !this.goldgdprice){
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(!this.$store.state.goldindex && !this.silvergdprice){
                    this.$toast('请先输入挂单价格')
                    return false;
                }

                var initnum = 1
                if(this.gddsclicktotal == 0 && this.gddsflag && !this.gdzhisundianshu){
                    this.gdzhisundianshu = 199
                }
                this.gddsclicktotal++
                this.gdzhisundianshu = this.NumberAdd(this.gdzhisundianshu,initnum)

            }

        },

        zhiyingdscut(){

            if(!this.changgetext){ //如果是市价交易页面

                var initnum = 1
                if(this.dsclicktotals == 0 && this.dsflags && !this.zhiyingdianshu){
                    this.zhiyingdianshu = 201
                }
                this.dsclicktotals++
                if(this.zhiyingdianshu <= 0) return false
                this.zhiyingdianshu = Number(this.Sub(this.zhiyingdianshu,initnum))

            }else if(this.changgetext){//如果是挂单交易页面

                if(this.$store.state.goldindex && !this.goldgdprice){
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(!this.$store.state.goldindex && !this.silvergdprice){
                    this.$toast('请先输入挂单价格')
                    return false;
                }

                var initnum = 1
                if(this.gddsclicktotals == 0 && this.gddsflags && !this.gdzhiyingdianshu){
                    this.gdzhiyingdianshu = 201
                }
                this.gddsclicktotals++
                if(this.gdzhiyingdianshu <= 0) return false
                this.gdzhiyingdianshu = Number(this.Sub(this.gdzhiyingdianshu,initnum))

            }

        },

        zhiyingdsadd(){

            if(!this.changgetext){ //如果是市价交易页面

                var initnum = 1
                if(this.dsclicktotals == 0 && this.dsflags && !this.zhiyingdianshu){
                    this.zhiyingdianshu = 199
                }
                this.dsclicktotals++
                this.zhiyingdianshu = Number(this.NumberAdd(this.zhiyingdianshu,initnum))

            }else if(this.changgetext){//如果是挂单交易页面

                if(this.$store.state.goldindex && !this.goldgdprice){
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(!this.$store.state.goldindex && !this.silvergdprice){
                    this.$toast('请先输入挂单价格')
                    return false;
                }

                var initnum = 1
                if(this.gddsclicktotals == 0 && this.gddsflags && !this.gdzhiyingdianshu){
                    this.gdzhiyingdianshu = 199
                }
                this.gddsclicktotals++
                this.gdzhiyingdianshu = Number(this.NumberAdd(this.gdzhiyingdianshu,initnum))

            }

        },

        removedianshuzhisun(){

            if(!this.changgetext){
                this.zhisundianshu = null
                this.dsclicktotal = 0
            }else if(this.changgetext){
                this.gdzhisundianshu = null
                this.gddsclicktotal = 0
            }

        },

        removedianshuzhiying(){

            if(!this.changgetext){
                this.zhiyingdianshu = null
                this.dsclicktotals = 0
            }else if(this.changgetext){
                this.gdzhiyingdianshu = null
                this.gddsclicktotals = 0
            }

        },


        NumberAdd(arg1, arg2){
            var r1,r2,m,n
            try{
                r1 = arg1.toString().split('.')[1].length
            } catch (e){
                r1 = 0
            }
            try{
                r2 = arg2.toString().split('.')[1].length
            } catch (e){
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            n = ( r1 >= r2 ) ? r1 : r2
            return ((arg1 * m + arg2 * m ) / m ).toFixed(n)
        },

        Sub(arg1, arg2) {
            arg1 = parseFloat(arg1);
            arg2 = parseFloat(arg2);
            var r1, r2, m, n;
            try {
                r1 = arg1.toString().split(".")[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(".")[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2));
            //动态控制精度长度
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m ) / m ).toFixed(2)
        },

    // 黄金
        // 获取到input值传给父组件gold,silver
        goldoninput(e){
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.goldfirment = e.target.value
            this.flag = false
        },

        goldoninputs(e){
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            this.goldsecment = e.target.value
            this.flags = false
        },

        // 黄金止损加减
        add(){
            
            var initnum = 0.01
            if(this.clicktotal == 0 && this.flag == true){
                if(!this.changgetext){ //市价交易页面
                    this.goldfirment = this.$store.state.goldSell
                }else if(!this.goldgdprice  && this.changgetext){ //如果没有挂单价格且是挂单页面，先让输入挂单价格防止弹框金额计算失效
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(this.goldgdprice && this.changgetext){  //挂单input有金额且是挂单页面时 止损input的操作

                    if(this.$store.state.dealtype == '限价买入'){
                        this.goldfirment = (this.Sub(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '限价卖出'){
                        this.goldfirment = (this.NumberAdd(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '止损买入'){
                        this.goldfirment = (this.Sub(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '止损卖出'){
                        this.goldfirment = (this.NumberAdd(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == "停损限价买入"){
                        if(!this.goldtsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.goldfirment = (this.Sub(this.goldtsprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == "停损限价卖出"){
                        if(!this.goldtsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.goldfirment = (this.NumberAdd(this.goldtsprice,(this.$store.state.goldstopsLevel/100)))
                    }

                }else if(!this.goldgdprice || this.goldgdprice == null && this.changgetext){ //挂单input没有金额且是挂单页面时 止损input的操作
                    this.goldfirment = this.goldDealTypePrice
                }
            }

            this.clicktotal++
            this.goldfirment = this.NumberAdd(this.goldfirment,initnum)

        },

        cut(){
            var initnum = 0.01
            if(this.clicktotal == 0 && this.flag == true){
                if(!this.changgetext){ // 市场交易页面
                    this.goldfirment = this.$store.state.goldSell
                }else if(!this.goldgdprice  && this.changgetext){ //如果没有挂单价格且是挂单页面，先让输入挂单价格防止弹框金额计算失效
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(this.goldgdprice && this.changgetext){ //挂单input有金额且是挂单页面时 止盈input的操作
                    if(this.$store.state.dealtype == '限价买入'){
                        this.goldfirment = (this.Sub(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '限价卖出'){
                        this.goldfirment = (this.NumberAdd(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '止损买入'){
                        this.goldfirment = (this.Sub(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '止损卖出'){
                        this.goldfirment = (this.NumberAdd(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == "停损限价买入"){
                        if(!this.goldtsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.goldfirment = (this.Sub(this.goldtsprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == "停损限价卖出"){
                        if(!this.goldtsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.goldfirment = (this.NumberAdd(this.goldtsprice,(this.$store.state.goldstopsLevel/100)))
                    }
                }else if(!this.goldgdprice || this.goldgdprice == null && this.changgetext){
                    this.goldfirment = this.goldDealTypePrice
                }
            }
            this.clicktotal++
            if(this.goldfirment <= 0)return false
            this.goldfirment = this.Sub(this.goldfirment,initnum)
        },

        reset(){
            this.goldfirment = null
            this.clicktotal = 0
            this.flag = true
        },
        // 黄金止损加减

        // 黄金止盈加减
        adds(){
            var initnum = 0.01
            if(this.clicktotals == 0 && this.flags == true){
                if(!this.changgetext){ //挂单交易页面
                    this.goldsecment = this.$store.state.goldSell
                }else if(!this.goldgdprice  && this.changgetext){ //如果没有挂单价格且是挂单页面，先让输入挂单价格防止弹框金额计算失效
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(this.goldgdprice && this.changgetext){ //挂单input有金额且是挂单页面时 止盈input的操作
                    if(this.$store.state.dealtype == '限价买入'){
                        this.goldsecment = (this.NumberAdd(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '限价卖出'){
                        this.goldsecment = (this.Sub(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '止损买入'){
                        this.goldsecment = (this.NumberAdd(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '止损卖出'){
                        this.goldsecment = (this.Sub(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == "停损限价买入"){
                        if(!this.goldtsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.goldsecment = (this.NumberAdd(this.goldtsprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == "停损限价卖出"){
                        if(!this.goldtsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.goldsecment = (this.Sub(this.goldtsprice,(this.$store.state.goldstopsLevel/100)))
                    }
                }else if(!this.goldgdprice || this.goldgdprice == null && this.changgetext){ //挂单input没有金额且是挂单页面时 止盈input的操作
                    this.goldsecment = this.goldDealTypePrice
                }
            }
            this.clicktotals++
            this.goldsecment = this.NumberAdd(this.goldsecment,initnum)
        },

        cuts(){
            var initnum = 0.01
            if(this.clicktotals == 0 && this.flags == true){
                if(!this.changgetext){ // 市场交易页面
                    this.goldsecment = this.$store.state.goldSell
                }else if(!this.goldgdprice  && this.changgetext){ //如果没有挂单价格且是挂单页面，先让输入挂单价格防止弹框金额计算失效
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(this.goldgdprice && this.changgetext){ //挂单input有金额且是挂单页面时 止盈input的操作
                    if(this.$store.state.dealtype == '限价买入'){
                        this.goldsecment = (this.NumberAdd(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '限价卖出'){
                        this.goldsecment = (this.Sub(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '止损买入'){
                        this.goldsecment = (this.NumberAdd(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == '止损卖出'){
                        this.goldsecment = (this.Sub(this.goldgdprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == "停损限价买入"){
                        if(!this.goldtsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.goldsecment = (this.NumberAdd(this.goldtsprice,(this.$store.state.goldstopsLevel/100)))
                    }else if(this.$store.state.dealtype == "停损限价卖出"){
                        if(!this.goldtsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.goldsecment = (this.Sub(this.goldtsprice,(this.$store.state.goldstopsLevel/100)))
                    }
                }else if(!this.goldgdprice || this.goldgdprice == null && this.changgetext){
                    this.goldsecment = this.goldDealTypePrice
                }
            }
            this.clicktotals++
            if(this.goldsecment <= 0)return false
            this.goldsecment = this.Sub(this.goldsecment,initnum)
        },

        resets(){
            this.goldsecment = null
            this.clicktotals = 0
            this.flags = true
        },
        // 黄金止盈加减

    //黄金 

    // 白银
        silveroninput(e){
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            this.silverfirment = e.target.value
            this.silverflag = false
        },
        silveroninputs(e){
            e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            this.silversecment = e.target.value
            this.silverflags = false
        },

        // 白银止损加减

        silveradd(){
            var initnum = 0.001
            if(this.silverclicktotal == 0 && this.silverflag == true){
                if(!this.changgetext){ // 市价交易页面
                     this.silverfirment = this.$store.state.silverSell
                }else if(!this.silvergdprice && this.changgetext){//如果没有挂单价格且是挂单页面，先让输入挂单价格防止弹框金额计算失效
                    this.$toast('请先输入挂单价格')
                    return false;
                } else if(this.silvergdprice && this.changgetext){ //挂单input有金额且是挂单页面时 止盈input的操作
                    if(this.$store.state.sldealtype == '限价买入'){
                        this.silverfirment = (this.Sub(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '限价卖出'){
                        this.silverfirment = (this.NumberAdd(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '止损买入'){
                        this.silverfirment = (this.Sub(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '止损卖出'){
                        this.silverfirment = (this.NumberAdd(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == "停损限价买入"){
                        if(!this.silvertsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.silverfirment = (this.silvertsprice - (this.$store.state.silverstopsLevel/1000))
                    }else if(this.$store.state.sldealtype == "停损限价卖出"){
                        if(!this.silvertsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.silverfirment = (this.NumberAdd(this.silvertsprice,(this.$store.state.silverstopsLevel/1000)))
                    }
                }else if(!this.silvergdprice || this.silvergdprice == null && this.changgetext){ //挂单input没有金额且是挂单页面时 止损input的操作
                    this.silverfirment = (this.Sub(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000)))
                }
            }
            this.silverclicktotal++
            this.silverfirment = this.NumberAdd(this.silverfirment,initnum)
        },

        silvercut(){
            var initnum = 0.001
            if(this.silverclicktotal == 0 && this.silverflag == true){
                if(!this.silverfirment && !this.changgetext){ // 市场交易页面
                    this.silverfirment = this.$store.state.silverSell
                }else if(!this.silvergdprice && this.changgetext){//如果没有挂单价格且是挂单页面，先让输入挂单价格防止弹框金额计算失效
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(this.silvergdprice && this.changgetext){ //挂单input有金额且是挂单页面时 止盈input的操作
                    if(this.$store.state.sldealtype == '限价买入'){
                        this.silverfirment = (this.Sub(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '限价卖出'){
                        this.silverfirment = (this.NumberAdd(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '止损买入'){
                        this.silverfirment = (this.Sub(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '止损卖出'){
                        this.silverfirment = (this.NumberAdd(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == "停损限价买入"){
                        if(!this.silvertsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.silverfirment = (this.Sub(this.silvertsprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == "停损限价卖出"){
                        if(!this.silvertsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.silverfirment = (this.NumberAdd(this.silvertsprice,(this.$store.state.silverstopsLevel/1000)))
                    }
                }else if(!this.silvergdprice || this.silvergdprice == null && this.changgetext){
                    this.silverfirment = (this.Sub(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000)))
                }
            }
            this.silverclicktotal++
            if(this.silverfirment <= 0)return false
            this.silverfirment = (this.silverfirment-initnum).toFixed(3)
        },

        silverreset(){
            this.silverfirment = null
            this.silverclicktotal = 0
            this.silverflag = true
        },
        // 白银止损加减


        // 白银止盈加减
        silveradds(){
            var initnum = 0.001
            if(this.silverclicktotals == 0 && this.silverflags == true){
                if(!this.changgetext){ //市场交易页面
                     this.silversecment = this.$store.state.silverSell
                }else if(!this.silvergdprice && this.changgetext){//如果没有挂单价格且是挂单页面，先让输入挂单价格防止弹框金额计算失效
                    this.$toast('请先输入挂单价格')
                    return false;
                }else if(this.silvergdprice && this.changgetext){ //挂单input有金额且是挂单页面时 止盈input的操作
                    if(this.$store.state.sldealtype == '限价买入'){
                        this.silversecment = (this.NumberAdd(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '限价卖出'){
                        this.silversecment = (this.Sub(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '止损买入'){
                        this.silversecment = (this.NumberAdd(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '止损卖出'){
                        this.silversecment = (this.Sub(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == "停损限价买入"){
                        if(!this.silvertsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.silversecment = (this.NumberAdd(this.silvertsprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == "停损限价卖出"){
                        if(!this.silvertsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.silversecment = (this.Sub(this.silvertsprice,(this.$store.state.silverstopsLevel/1000)))
                    }
                }else if(!this.silvergdprice || this.silvergdprice == null && this.changgetext){ //挂单input没有金额且是挂单页面时 止盈input的操作
                    this.silversecment = (this.Sub(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000)))
                }
            }
            this.silverclicktotals++
            this.silversecment = this.NumberAdd(this.silversecment,initnum)
        },

        silvercuts(){
            var initnum = 0.001
            if(this.silverclicktotals == 0 && this.silverflags == true){
                if(!this.silversecment && !this.changgetext){ // 市场交易页面
                    this.silversecment = this.$store.state.silverSell
                }else if(!this.silvergdprice && this.changgetext){//如果没有挂单价格且是挂单页面，先让输入挂单价格防止弹框金额计算失效
                    this.$toast('请先输入挂单价格')
                    return false;
                } else if(this.silvergdprice && this.changgetext){ //挂单input有金额且是挂单页面时 止盈input的操作
                    if(this.$store.state.sldealtype == '限价买入'){
                        this.silversecment = (this.NumberAdd(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '限价卖出'){
                        this.silversecment = (this.Sub(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '止损买入'){
                        this.silversecment = (this.NumberAdd(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == '止损卖出'){
                        this.silversecment = (this.Sub(this.silvergdprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == "停损限价买入"){
                        if(!this.silvertsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.silversecment = (this.NumberAdd(this.silvertsprice,(this.$store.state.silverstopsLevel/1000)))
                    }else if(this.$store.state.sldealtype == "停损限价卖出"){
                        if(!this.silvertsprice){
                            this.$toast("请先输入停损价格")
                            return false;
                        }
                        this.silversecment = (this.Sub(this.silvertsprice,(this.$store.state.silverstopsLevel/1000)))
                    }
                }else if(!this.silvergdprice || this.silvergdprice == null && this.changgetext){
                    this.silversecment = (this.Sub(this.$store.state.silverBuy,(this.$store.state.silverstopsLevel/1000)))
                }
            }
            this.silverclicktotals++
            if(this.silversecment <= 0)return false
            this.silversecment = (this.silversecment-initnum).toFixed(3)
        },

        silverresets(){
            this.silversecment = null
            this.silverclicktotals = 0
            this.silverflags = true
        },
        // 白银止盈加减

    // 白银



        changeicon(){
            this.slideshow = !this.slideshow
        },
        // 控制交易手数高亮
        select(index){
            this.active = index
            var j = new Number(this.lotsarr[index].name)
            this.$emit('lotsarr',j)
            this.$emit('gdlotsarr',j)
        },

    },

    watch:{

        // 监听黄金止损
        'goldfirment'(val) {
                this.$emit('zhisun',val)
                if(val == null){
                    this.zhisunchang = false
                }else{
                    this.zhisunchang = true
                }
        },
        // 监听黄金止盈
        'goldsecment'(val){
            this.$emit('zhiying',val)
            if(val == null){
                this.zhiyingchang = false
            }else{
                this.zhiyingchang = true
            }
        },

        // 监听白银止损
        'silverfirment'(val){
                this.$emit('silverzhisun',val)
                if(val == null){
                    this.slzhisunchang = false
                }else{
                    this.slzhisunchang = true
                }
        },

        // 监听白银止盈
        'silversecment'(val){
                this.$emit('silverzhiying',val)
                if(val == null){
                    this.slzhiyingchang = false
                }else{
                    this.slzhiyingchang = true
                }
        },

        // 监听黄金价格
        'goldgdprice'(val){
            if(val){
                this.goldgdpricecg = true //必须在这里
            }else{
                this.goldgdpricecg = false
            }
            if(val && this.$store.state.dealtype == '限价买入'){
                this.gdzhisun = '<' + parseFloat((this.Sub(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)
                this.gdzhiying = '>' + parseFloat((this.NumberAdd(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)
            }else if(val && this.$store.state.dealtype == '限价卖出'){
                this.gdzhisun = '>' + parseFloat((this.NumberAdd(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2) 
                this.gdzhiying = '<'+ parseFloat((this.Sub(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)

            }else if(val && this.$store.state.dealtype == '止损买入'){
                this.gdzhisun = '<' + parseFloat((this.Sub(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)
                this.gdzhiying = '>' + parseFloat((this.NumberAdd(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)

            }else if(val && this.$store.state.dealtype == '止损卖出'){
                this.gdzhisun = '>' + parseFloat((this.NumberAdd(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)
                this.gdzhiying = '<' + parseFloat((this.Sub(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)

            }

        },
        // 监听白银价格
        'silvergdprice'(val){
            if(val){
                this.silvergdpricecg = true
            }else{
                this.silvergdpricecg = false
            }

            if(val && this.$store.state.sldealtype == '限价买入'){

                this.slgdzhisun = '<' + ((val-(this.$store.state.silverstopsLevel/1000)).toFixed(3))
                this.slgdzhiying = '>'+ (this.NumberAdd(val,(this.$store.state.silverstopsLevel/1000)))

            }else if(val && this.$store.state.sldealtype == '限价卖出'){

                this.slgdzhisun = '>' + (this.NumberAdd(val,(this.$store.state.silverstopsLevel/1000)))
                this.slgdzhiying = '<'+ ((val-(this.$store.state.silverstopsLevel/1000)).toFixed(3))

            }else if(val && this.$store.state.sldealtype == '止损买入'){

                this.slgdzhisun = '<' + ((val-(this.$store.state.silverstopsLevel/1000)).toFixed(3))
                this.slgdzhiying = '>' + (this.NumberAdd(val,(this.$store.state.silverstopsLevel/1000)))

            }else if(val && this.$store.state.sldealtype == '止损卖出'){

                this.slgdzhisun = '>' + (this.NumberAdd(val,(this.$store.state.silverstopsLevel/1000)))
                this.slgdzhiying = '<' + ((val-(this.$store.state.silverstopsLevel/1000)).toFixed(3))

            }

        },

        // 监听黄金停损限价
        'goldtsprice'(val){
            if(val){
                this.goldgdpricecg = true
            }else{
                this.goldgdpricecg = false
            }
            if(val && this.$store.state.dealtype == "停损限价买入"){
                this.gdzhisun = '<' + parseFloat((this.Sub(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)
                this.gdzhiying = '>' + parseFloat((this.NumberAdd(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)
            }else if(val && this.$store.state.dealtype == "停损限价卖出"){
                this.gdzhisun = '>' + parseFloat((this.NumberAdd(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)
                this.gdzhiying = '<' + parseFloat((this.Sub(val,(this.$store.state.goldstopsLevel/100)))).toFixed(2)
            }
        },

        // 监听白银停损价
        'silvertsprice'(val){
            if(val){
                this.silvergdpricecg = true
            }else{
                this.silvergdpricecg = false
            }

            if(val && this.$store.state.sldealtype == "停损限价买入"){

                this.slgdzhisun = '<' + ((val-(this.$store.state.silverstopsLevel/1000)).toFixed(3))
                this.slgdzhiying = '>'+ parseFloat(this.NumberAdd(val,(this.$store.state.silverstopsLevel/1000))).toFixed(3)

            }else if(val && this.$store.state.sldealtype == "停损限价卖出"){

                this.slgdzhisun = '>' + parseFloat(this.NumberAdd(val,(this.$store.state.silverstopsLevel/1000))).toFixed(3)
                this.slgdzhiying = '<'+ ((val-(this.$store.state.silverstopsLevel/1000)).toFixed(3))

            }
        },


        // 监听挂单预付款
        'navtabcurrentindex'(val){
            if(val == 0){
                this.yfkflag = true
                this.changgetext = false
                this.slchanggetext = false
            }else{
                this.yfkflag = false
                this.changgetext = true
                this.slchanggetext = false
            }
        },

        // 监听市价止损点数计算预计值
        'zhisundianshu'(val){
            if(this.$store.state.goldindex){
                this.$emit('goldzhisunds',val) //传给父组件市价止损点数
                this.getsjdszhisun = '预计 ' + ((0 - (val * 0.001)) * this.initlot * 1000).toFixed(2) + ' 美元'
            }else if(!this.$store.state.goldindex){
                this.$emit('zhisunds',val) //传给父组件市价止损点数
                this.getsjdszhisun =  '预计 ' + ((0 - (val * 0.001)) * this.initlot * 5000).toFixed(2) + ' 美元'
            }
        },

        // 监听市价止盈点数计算预计值
        'zhiyingdianshu'(val){
            if(this.$store.state.goldindex){
                this.$emit('goldzhiyingds',val) //传给父组件市价止盈点数
                this.getsjdszhiying =  '预计 ' + ((0 + (val * 0.001)) * this.initlot * 1000).toFixed(2) + ' 美元'
            }else if(!this.$store.state.goldindex){
                this.$emit('zhiyingds',val) //传给父组件市价止盈点数
                this.getsjdszhiying =  '预计 ' + ((0 + (val * 0.001)) * this.initlot * 5000).toFixed(2) + ' 美元'
            }
        },

        //监听挂单止损点数计算预计值
        'gdzhisundianshu'(val){
            if(this.$store.state.goldindex){
                this.$emit('gdzhisunds',val) //传给父组件挂单止损点数
                this.getgddszhisun = '预计 ' + ((0 - (val * 0.001)) * this.gdinitlot * 1000).toFixed(2) + ' 美元'

                if(this.$store.state.dealtype == '限价买入'){
                    this.$store.state.goldchanggezhisun = this.Sub(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '限价卖出'){
                    this.$store.state.goldchanggezhisun = this.NumberAdd(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '止损买入'){
                    this.$store.state.goldchanggezhisun = this.Sub(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '止损卖出'){
                    this.$store.state.goldchanggezhisun = this.NumberAdd(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == "停损限价买入"){
                    this.$store.state.goldchanggezhisun = this.Sub(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == "停损限价卖出"){
                    this.$store.state.goldchanggezhisun = this.NumberAdd(this.goldgdprice,(val / 100).toFixed(2))
                }

            }else if(!this.$store.state.goldindex){
                this.$emit('gdzhisunds',val) //传给父组件挂单止损点数
                this.getgddszhisun = '预计 ' + ((0 - (val * 0.001)) * this.gdinitlot * 5000).toFixed(2) + ' 美元'

                if(this.$store.state.sldealtype == '限价买入'){

                    this.$store.state.changgezhisun = (this.silvergdprice-(val / 1000)).toFixed(3) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == '限价卖出'){

                    this.$store.state.changgezhisun = this.NumberAdd(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == '止损买入'){

                    this.$store.state.changgezhisun = (this.silvergdprice-(val / 1000)).toFixed(3) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == '止损卖出'){

                    this.$store.state.changgezhisun = this.NumberAdd(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == "停损限价买入"){

                    this.$store.state.changgezhisun = (this.silvergdprice-(val / 1000)).toFixed(3) //白银页面挂单弹出框的止损点数转换成止损价格

                }else if(this.$store.state.sldealtype == "停损限价卖出"){

                    this.$store.state.changgezhisun = this.NumberAdd(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止损点数转换成止损价格

                }

            }
        },

        //监听挂单止盈点数计算预计值
        'gdzhiyingdianshu'(val){
            if(this.$store.state.goldindex){
                this.$emit('gdzhiyingds',val) //传给父组件挂单止盈点数
                this.getgddszhiying = '预计 ' + ((0 + (val * 0.001)) * this.gdinitlot * 1000).toFixed(2) + ' 美元'

                if(this.$store.state.dealtype == '限价买入'){
                    this.$store.state.goldchanggezhiying = this.NumberAdd(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '限价卖出'){
                    this.$store.state.goldchanggezhiying = this.Sub(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '止损买入'){
                    this.$store.state.goldchanggezhiying = this.NumberAdd(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == '止损卖出'){
                    this.$store.state.goldchanggezhiying = this.Sub(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == "停损限价买入"){
                    this.$store.state.goldchanggezhiying = this.Sub(this.goldgdprice,(val / 100).toFixed(2))
                }else if(this.$store.state.dealtype == "停损限价卖出"){
                    this.$store.state.goldchanggezhiying = this.Sub(this.goldgdprice,(val / 100).toFixed(2))
                }

            }else if(!this.$store.state.goldindex){
                this.$emit('gdzhiyingds',val) //传给父组件挂单止盈点数
                this.getgddszhiying = '预计 ' + ((0 + (val * 0.001)) * this.gdinitlot * 5000).toFixed(2) + ' 美元'

                if(this.$store.state.sldealtype == '限价买入'){

                    this.$store.state.changgezhiying = this.NumberAdd(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格

                }else if(this.$store.state.sldealtype == '限价卖出'){
                    
                    this.$store.state.changgezhiying = this.Sub(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格

                }else if(this.$store.state.sldealtype == '止损买入'){

                    this.$store.state.changgezhiying = this.NumberAdd(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格

                }else if(this.$store.state.sldealtype == '止损卖出'){

                    this.$store.state.changgezhiying = this.Sub(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格
                    
                }else if(this.$store.state.sldealtype == "停损限价买入"){

                    this.$store.state.changgezhiying = this.NumberAdd(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格
                    
                }else if(this.$store.state.sldealtype == "停损限价卖出"){

                    this.$store.state.changgezhiying = this.Sub(this.silvergdprice,(val / 1000).toFixed(3)) //白银页面挂单弹出框的止盈点数转换成止盈价格
                    
                }
            }
        },

        //监听清空黄金止盈止损价格和点数
        'gdzhisundss'(val){
            if(val == null){
                this.removedianshuzhisun() //清空止损点数
            }
        },
        'gdzhiyingdss'(val){
            if(val == null){
                this.removedianshuzhiying() //清空止盈点数
            }
        },
        'gdgoldzhisun'(val){
            if(val == null){
                this.reset() //清空黄金止损价格
            }
        },
        'gdgoldzhiying'(val){
            if(val == null){
                this.resets() //清空黄金止盈价格
            }
        },

        //监听清空白银止盈止损价格和点数
        'gdsilverzs'(val){
            if(val == null){
                this.silverreset() //清空白银止损价格
            }
        },

        'gdsilverzy'(val){
            if(val == null){
                this.silverresets() //清空白银止盈价格
            }
        },

        'gdsilverzyds'(val){
            if(val==null){
                this.removedianshuzhiying() //清空止盈点数
            }
        },

        'gdsilverzsds'(val){
            if(val == null){
                this.removedianshuzhisun() //清空止损点数
            }
        },

        getgoldindex(gold){
            if(gold){
                this.goldflag = true

            }else{
                this.goldflag = false
            }
        },
        getsilverindex(message){
            
        },
    },

    computed:{

        ...mapGetters([
            'getterSocketData',
            'getgoldindex',
            // 'getsilverindex'
        ]),

        // 计算黄金止损预计
        comtotalzhisun(){
            if(this.$store.state.dealtype == '限价买入'){
                return '预计' + (((this.goldfirment - this.goldgdprice)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == '限价卖出'){
                return '预计' + (((this.goldgdprice - this.goldfirment)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == '止损买入'){
                return '预计' + (((this.goldfirment - this.goldgdprice)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == '止损卖出'){
                return '预计' + (((this.goldgdprice - this.goldfirment)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == '停损限价买入'){
                return '预计' + (((this.goldfirment - this.goldgdprice)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == '停损限价卖出'){
                return '预计' + (((this.goldgdprice - this.goldfirment)*this.gdinitlot)*100).toFixed(2)
            }
        },

        // 计算黄金止盈预计
        comtotalzhiying(){
            if(this.$store.state.dealtype == '限价买入'){
                return '预计' + (((this.goldsecment - this.goldgdprice)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == '限价卖出'){
                return '预计' + (((this.goldgdprice - this.goldsecment)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == '止损买入'){
                return '预计' + (((this.goldsecment - this.goldgdprice)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == '止损卖出'){
                return '预计' + (((this.goldgdprice - this.goldsecment)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == "停损限价买入"){
                return '预计' + (((this.goldsecment - this.goldgdprice)*this.gdinitlot)*100).toFixed(2)
            }else if(this.$store.state.dealtype == "停损限价卖出"){
                return '预计' + (((this.goldgdprice - this.goldsecment)*this.gdinitlot)*100).toFixed(2)
            }
        },

        // 计算白银止损预计
        slcomtotalzhisun(){
            if(this.$store.state.sldealtype == '限价买入'){
                return '预计' + (((this.silverfirment - this.silvergdprice)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == '限价卖出'){
                return '预计' + (((this.silvergdprice - this.silverfirment)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == '止损买入'){
                return '预计' + (((this.silverfirment - this.silvergdprice)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == '止损卖出'){
                return '预计' + (((this.silvergdprice - this.silverfirment)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == "停损限价买入"){
                return '预计' + (((this.silverfirment - this.silvergdprice)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == "停损限价卖出"){
                return '预计' + (((this.silvergdprice - this.silverfirment)*this.gdinitlot)*5000).toFixed(2)
            }
        },

        // 计算白银止盈预计
        slcomtotalzhiying(){
            if(this.$store.state.sldealtype == '限价买入'){
                return '预计' + (((this.silversecment - this.silvergdprice)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == '限价卖出'){
                return '预计' + (((this.silvergdprice - this.silversecment)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == '止损买入'){
                return '预计' + (((this.silversecment - this.silvergdprice)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == '止损卖出'){
                return '预计' + (((this.silvergdprice - this.silversecment)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == "停损限价买入"){
                return '预计' + (((this.silversecment - this.silvergdprice)*this.gdinitlot)*5000).toFixed(2)
            }else if(this.$store.state.sldealtype == "停损限价卖出"){
                return '预计' + (((this.silvergdprice - this.silversecment)*this.gdinitlot)*5000).toFixed(2)
            }
        },


    },

    mounted(){

    }
}
</script>

<style scoped>
    body{touch-action: none;}
    .dealpricebox{margin: 0 15.33px;background-color: #FFFFFF;}
    .dealpricebox-title{display: flex;justify-content: space-between;align-items: center;padding-bottom: 12.67px;}
    .dealpricebox-title p:nth-of-type(1){color: #999999;font-size: 12px;}
    .dealpricebox-title p:nth-of-type(2){color: #999999;font-size: 12px;display: flex;align-items: center;}
    .dealpricebox-tittle p:nth-of-type(2) span{color: #333333;}

    .dealpricebox ul{width: 100%;height: 26px;display: flex;align-items: center;justify-content: space-between;}
    .dealpricebox ul li{height: 100%;width: 18.1%; display: flex;justify-content: center;align-items: center;color: #999999;font-size: 12px;background-color: #F8F8F8;}
    
    .setprice{display: flex;align-items: center;justify-content: space-between;padding-top: 13px;}
    .setprice .left{color: #999999;font-size: 14px;}
    .setprice .right{display: flex;justify-content: space-between;align-items: center;}
    .setprice .right .box{display: flex;align-items: center;}
    .setprice .right .box .right-price{width: 50px;height: 20px;font-size: 12px !important;display: flex;justify-content: center;align-items: center;border-top-left-radius: 11px;border-bottom-left-radius: 11px;border-top-right-radius: 0;border-bottom-right-radius: 0;}
    .setprice .right .box .right-amount{width: 50px;height: 20px; font-size: 12px !important;display: flex;justify-content: center;align-items: center;border-top-right-radius: 11px;border-bottom-right-radius: 11px;border-top-left-radius: 0;border-bottom-left-radius: 0;}
    .setprice .right img{width: 24px;height: 24px;display: block;margin-left: 12.67px;transition: all 0.5s;}
    
    /* 价格点数切换 */
    .dsactive{display: block;width: 36px;height: 22px;border-radius: 9px;color: #FF4F36 !important; text-align: center;line-height: 18px;border: none;background-color: #FFEDEA !important;border: 1px solid #FFEDEA;}
    .dsactived{display: block;width: 36px;height: 20px;border-radius: 9px;text-align: center;line-height: 18px;border: 1px solid #FFEDEA;}


    .cut{width: 22px;height: 22px;display: block;margin-right: 10px;}
    .add{width: 22px;height: 22px;display: block;margin-left: 10px;}
    .sliderdown-item{height: 50px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #EEEEEE;}
    .sliderdown-item p:nth-of-type(1){color: #333333;font-size: 14px;display: flex;align-items: center;justify-content: flex-start;flex: 1;}
    .sliderdown-item p:nth-of-type(1) span{color: #999999;font-size: 12px;padding-left: 8.33px;}
    .sliderdown-item p:nth-of-type(2){color: #333333;font-size: 14px;font-weight: bold;display: flex;align-items: center;text-align: right;flex: 1;justify-content: flex-end;}
    .sliderdown-item p:nth-of-type(2) span:nth-of-type(1){width: 60px;}
    .sliderdown-item p:nth-of-type(2) span:nth-of-type(2){color: #999999;font-size: 14px;padding-left: 5px;font-weight: normal;}
    .sliderdown-item p:nth-of-type(2) .icon-right{width: 16px;height: 16px;display: block;}

    .slide-item{height: 50px;border-bottom: 1px solid #EEEEEE;}
    .slide-item .dealbox{height: 50px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #EEEEEE;}
    .slide-item .dealbox .left{display: flex;align-items: center;flex: 1;}
    .slide-item .dealbox .ctrlbox{display: flex;align-items: center;flex: 1;justify-content: flex-end;}
    .slide-item .dealbox .left p{color: #333333;font-size: 14px;}
    .slide-item .dealbox .left p span{color: #999999;padding-left: 9px;font-size: 12px;}
    .slide-item .dealbox .main img{width: 22px;height: 22px;display: block;margin-right: 10px;}
    .slide-item .dealbox .right{display: flex;justify-content: center;align-items: center;}
    .slide-item .dealbox .right img{width: 22px;height: 22px;display: block;margin-left: 10px;}
    .slide-item .dealbox .right span:nth-of-type(1){color: #BBBBBB;font-size: 16px;font-weight: bold;width: 60px;}
    .slide-item .dealbox .right span:nth-of-type(3){color: #999999;font-size: 14px;text-align: right;}
    .slide input{text-align: center;outline: none;border: none;width:100%;display:flex;justify-content: center;align-items: center;font-size: 16px;font-weight: bold; color: #333333;}
    .slide input::placeholder{color: #BBBBBB;}

    .active{background: #FFEDEA !important;color: #FF4F36 !important;}
    .actived{background: #FFEDEA !important;color: #FF4F36 !important;}

    /* 遮罩层 */
    .mask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 887;}

    /* faq盒子 */
    .faq{width: 300px;border-radius: 12px;background-color: #FFFFFF;position: fixed;top: 40%;left: 0;right: 0;z-index: 888;margin: 0 auto;}
    .faq-title{padding: 17.67px 0 20.33px 0;color: #333333;font-weight: bold;font-size: 16px;text-align: center;}
    .faq-content{border-bottom: 1px solid #F5F5F5;padding: 0 20px 20.33px 20px;line-height: 24px;}
    .faq-content p{font-size: 12px;}
    .faq-bottom{padding: 17.33px 0;text-align: center;color: #FF4F36;font-size: 16px;font-weight: bold;}
</style>


// WEBPACK FOOTER //
// src/components/dealprice.vue